import React from 'react';
import { Accordion } from '@yme/atoms/accordion';
import { TitleStyled } from './styled';
export function FAQSection(props) {
    const { isRightToLeft, title, accordionData, onOpened } = props;
    return (React.createElement("div", null,
        title && React.createElement(TitleStyled, null, title),
        React.createElement(Accordion, { hasContainerPadding: false, data: accordionData, onOpened: onOpened, isRightToLeft: isRightToLeft })));
}
